import { render, staticRenderFns } from "./can-you-stop-the-bleeding.vue?vue&type=template&id=c1eb1a40&"
import script from "./can-you-stop-the-bleeding.vue?vue&type=script&lang=js&"
export * from "./can-you-stop-the-bleeding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports